import React from 'react';
import './PentestMockup.css';

// Animated "live VAPT" panel used in place of a static screenshot on the
// Penetration Testing card — a target under active test with the attack surface
// being swept and severity-tagged findings streaming in.
const findings = [
  { sev: 'CRIT', label: 'SQL Injection', ref: '/search?q=' },
  { sev: 'HIGH', label: 'Broken Access Control (IDOR)', ref: '/api/v1/users' },
  { sev: 'HIGH', label: 'Cross-Site Scripting', ref: '/profile' },
  { sev: 'MED', label: 'Security Misconfiguration', ref: 'headers' },
];

const PentestMockup = () => (
  <div className="pm" role="img" aria-label="Live penetration test finding vulnerabilities on a target application">
    <div className="pm-bar">
      <span className="pm-dot r" /><span className="pm-dot y" /><span className="pm-dot g" />
      <span className="pm-target">target · app.example.com</span>
      <span className="pm-status"><i />SCANNING</span>
    </div>

    <div className="pm-body">
      <div className="pm-scan" aria-hidden="true" />

      <div className="pm-surface">
        <span className="pm-slabel">Attack surface</span>
        <div className="pm-nodes">
          <div className="pm-line"><i /></div>
          {[0, 1, 2, 3, 4].map((n) => (
            <span className={`pm-node ${n === 1 || n === 3 ? 'hit' : ''}`} key={n} style={{ animationDelay: `${n * 0.25}s` }} />
          ))}
        </div>
      </div>

      <div className="pm-feed">
        {findings.map((f, i) => (
          <div className="pm-find" key={f.label} style={{ animationDelay: `${0.3 + i * 0.55}s` }}>
            <span className={`pm-sev ${f.sev.toLowerCase()}`}>{f.sev}</span>
            <span className="pm-fl">{f.label}</span>
            <span className="pm-fr">{f.ref}</span>
          </div>
        ))}
      </div>
    </div>

    <div className="pm-foot">
      <div className="pm-count"><b>14</b> findings validated</div>
      <div className="pm-sevbars">
        <span className="pm-bcrit" /><span className="pm-bhigh" /><span className="pm-bmed" />
      </div>
    </div>
  </div>
);

export default PentestMockup;
